/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {
    useEffect,
    useState,
    useRef,
    Fragment
} from 'react';
import consultaApi from '../../../services/consultaApi';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Swal from 'sweetalert2';
import { withRouter } from 'react-router-dom';
import Tabela from './tabela.js';
import SearchIcon from '@material-ui/icons/Search';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import CircularProgress from '@material-ui/core/CircularProgress';


const useStyles = makeStyles(theme => ({
    controlaTitulo: {
        marginTop: theme.spacing(2),
    },
    formControl: {
        marginBottom: theme.spacing(2),
    },
    controlaLoading: {
        marginLeft: '50%',
        marginTop: '50%',
        height: '100%'
    }
}));

function ListagemHeader(props, { history }) {

    const classes = useStyles();

    const inputLabelModificacao = useRef(null);
    const inputLabelFiltros = useRef(null);
    const [modificacao, setModificacao] = useState(-1);
    const [labelWidthModificacao] = useState(0);
    const [labelWidthFiltros] = useState(0);
    const [valorPesquisa, setValorPesquisa] = useState('');
    const [arrayFiltros, setArrayFiltros] = useState([]);
    const [filtro, setFiltro] = useState(props.filtros.dic[0].campoFiltro);
    const [controlaAlterar, setControlaAlterar] = useState();
    const [open, setOpen] = useState(false);
    const [controlaRemoveMascara, setControlaRemoveMascara] = useState(false);

    const [loading, setLoading] = useState(false);

    const [listaRegistros, setListaRegistros] = useState([]);

    useEffect(() => {
        setValorPesquisa('');
        arrayFiltros.map(objetoFiltro => {
            if (objetoFiltro.campoFiltro === filtro) {
                if (objetoFiltro.removeMascara) {
                    setControlaRemoveMascara(true);
                } else {
                    setControlaRemoveMascara(false);
                }
            }
        })
    }, [filtro])

    const handleChangeModificacao = event => {
        setModificacao(event.target.value);
    };

    const handleChangeFiltro = event => {
        setFiltro(event.target.value);
    }

    useEffect(() => {
        setArrayFiltros(props.filtros.dic);
    }, []);

    async function consultaBanco() {
        setLoading(true)
        let pesquisaRegex = valorPesquisa.replace(/\D/g, '').toString();
        let dadosEnvio = {
            CNPJ: localStorage.getItem("CNPJ"),
            MODIFICACAO: modificacao,
            APRESENTACAO: 'ATIVOS',
            FILTRO: filtro,
            VALORPESQUISA: controlaRemoveMascara ? pesquisaRegex : valorPesquisa,
            PROCNAME: props.metodoListagem,
        };
        const resposta = await consultaApi(dadosEnvio);

        let data = resposta.data;

        let pessoas = data.DATASET;

        setLoading(false);

        if (pessoas) {
            return Object.values(pessoas)
        } else {
            Swal.fire({
                type: 'error',
                title: 'Ooops!!!',
                html: `<lu><li>Não foram encontrados dados!</li></lu>`
            })
        }
    }

    async function pesquisar() {
        let retornoFunction = await consultaBanco();
        retornoFunction ? setControlaAlterar(false) : setControlaAlterar(true);
        setOpen(false);
        setListaRegistros(retornoFunction);
    }

    async function consultaServidor(chave, nomeChave) {

        let procedure = {
            PROCNAME: props.metodoConsultaUnica,
        };
        procedure[nomeChave] = chave;



        const resposta = await consultaApi(procedure);

        if (resposta.data.DATASET != null) {
            return resposta.data.DATASET[0];
        }

        return alert('Registro Corrompido. Envie um print ao suporte!')

    }

    async function alterar(chave) {
        let retornoFuncao = await consultaServidor(chave, props.nomeChave);

        retornoFuncao && props.vaiPara(retornoFuncao);
    }

    function pessoaToNfe(chave, descricao) {
        props.history.push('/cadastro-nfe', {
            pessoa: {
                CCDPESS: chave,
                CDSPESS: descricao,
            }
        })
    }

    const handleClickOpen = () => {
        setOpen(true);
    }

    const handleClose = () => {
        setOpen(false);
    }


    return (
        <Fragment>
            <div>
                <Container>
                    <Grid Container>

                        <Grid item xs={12}>
                            <Typography
                                variant="h5"
                                component="h5"
                                gutterBottom
                                align="center"
                                color="primary"
                                className={classes.controlaTitulo}
                            >
                                {props.titulo}
                            </Typography>
                        </Grid>

                        <Grid item xs={12}>
                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={() => props.vaiPara({})}
                                fullWidth
                            >
                                Novo
                            </Button>
                        </Grid>

                        <Grid item xs={12}>
                            <Button
                                variant="contained"
                                color="#F1F1F1"
                                onClick={handleClickOpen}
                                endIcon={<SearchIcon />}
                                fullWidth
                            >
                                Filtrar
                            </Button>

                            <Dialog
                                open={open}
                                onClose={handleClose}
                                aria-labelledby="Filtrar"
                                fullWidth
                            >
                                <DialogTitle id="filtrar">
                                    Filtrar
                                </DialogTitle>
                                <DialogContent>
                                    <Grid container>
                                        <Grid item xs={12}>
                                            <FormControl variant="outlined"
                                                fullWidth
                                                className={classes.formControl}>

                                                <InputLabel ref={inputLabelModificacao}>
                                                    Ultima Modificação
                                                </InputLabel>

                                                <Select
                                                    value={modificacao}
                                                    onChange={handleChangeModificacao}
                                                    labelWidth={labelWidthModificacao}
                                                >
                                                    <MenuItem value={0}>Hoje</MenuItem>
                                                    <MenuItem value={1}>Ontem</MenuItem>
                                                    <MenuItem value={7}>Uma Semana</MenuItem>
                                                    <MenuItem value={30}>Um Mês</MenuItem>
                                                    <MenuItem value={60}>Dois Meses</MenuItem>
                                                    <MenuItem value={180}>Seis Meses</MenuItem>
                                                    <MenuItem value={360}>Um Ano</MenuItem>
                                                    <MenuItem value={-1}>Qualquer Data</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <FormControl variant="outlined"
                                                fullWidth
                                                className={classes.formControl}>

                                                <InputLabel ref={inputLabelFiltros}>
                                                    Filtros
                                                </InputLabel>

                                                <Select
                                                    value={filtro ? filtro : 1}
                                                    onChange={handleChangeFiltro}
                                                    labelWidth={labelWidthFiltros}
                                                >
                                                    {arrayFiltros.map(filtro => (
                                                        <MenuItem value={filtro.campoFiltro}>{filtro.descricaoFiltro}</MenuItem>
                                                    ))}
                                                </Select>

                                            </FormControl>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <TextField
                                                label=""
                                                margin="normal"
                                                variant="outlined"
                                                fullWidth
                                                value={valorPesquisa}
                                                onChange={e => setValorPesquisa(e.target.value)}
                                            />
                                        </Grid>
                                    </Grid>
                                </DialogContent>
                                <DialogActions>
                                    <Button
                                        variant="filled"
                                        color="primary"
                                        onClick={pesquisar}
                                        fullWidth
                                    >
                                        Buscar
                                    </Button>
                                </DialogActions>
                            </Dialog>

                        </Grid>

                        <Grid item xs={12}>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={pesquisar}
                                fullWidth
                            >
                                Pesquisar
                        </Button>
                        </Grid>

                    </Grid>
                </Container>
            </div>

            {!loading ?
                <Tabela
                    listaRegistros={listaRegistros}
                    alterar={alterar}
                    pessoaToNfe={pessoaToNfe}
                    controlaAlterar={controlaAlterar}
                    colunas={props.columns.dic}
                />
                : <div className={classes.controlaLoading}>
                    <CircularProgress />
                </div>
            }

        </Fragment>
    )
}

export default withRouter(ListagemHeader);